import React from 'react'
import RenderPrintPdf from '../../../components/Impressao/RenderPrintPdf'
import SADTPdfDocument from '../../../template/pdf/SADT/SADT'

export const renderPrintPdf = ({ guiaServico, urlLogo, pdfToPrint, onAfterPrint }) => (
  <RenderPrintPdf
    pdfDocument={<SADTPdfDocument guiaServico={guiaServico} urlLogo={urlLogo} />}
    pdfToPrint={pdfToPrint}
    onAfterPrint={onAfterPrint}
  />
)
